const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 303.188 303.188",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E4E4E4"
    },
    points: "219.821,0 32.842,0 32.842,303.188 270.346,303.188 270.346,50.525  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 144.182,
    y: 12.631,
    style: {
      fill: "#333E48"
    },
    width: 14.824,
    height: 132.962
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A4A9AD"
    },
    d: "M151.594,134.594c-8.247,0-14.933,20.253-14.933,28.5s6.686,14.933,14.933,14.933 s14.933-6.686,14.933-14.933S159.841,134.594,151.594,134.594z M151.594,170.005c-3.817,0-6.912-3.094-6.912-6.912 s3.094-6.912,6.912-6.912c3.817,0,6.912,3.094,6.912,6.912S155.411,170.005,151.594,170.005z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A4A9AD"
    },
    points: "227.64,25.263 32.842,25.263 32.842,0 219.821,0  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A4A9AD"
    },
    d: "M136.769,273.871H99.39v-8.007l20.773-29.503H99.882v-10.469h36.362v7.975l-20.773,29.536h21.298 V273.871z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A4A9AD"
    },
    d: "M143.628,273.871v-47.979h13.028v47.979H143.628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A4A9AD"
    },
    d: "M201.847,241.152c0,5.361-1.581,9.501-4.742,12.421c-3.162,2.921-7.652,4.381-13.472,4.381h-3.643 v15.917h-12.963v-47.979h16.605c6.06,0,10.61,1.324,13.652,3.971C200.325,232.51,201.847,236.273,201.847,241.152z  M179.99,247.387h2.362c1.947,0,3.495-0.546,4.643-1.641c1.149-1.094,1.724-2.604,1.724-4.529c0-3.238-1.795-4.857-5.383-4.857 h-3.347L179.99,247.387L179.99,247.387z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D3D3"
    },
    points: "219.821,50.525 270.346,50.525 219.821,0  "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZip);
export default __webpack_public_path__ + "static/media/zip.5e940229065fba12f248ffc5875565c8.svg";
export { ForwardRef as ReactComponent };